import {Form as MobxReactForm} from 'utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'answer',
    rules: 'required|string'
  },
  {
    name: 'followUpAnswer',
    rules: 'string'
  },
  {
    name: 'user',
    rules: 'required|string'
  }
];

export default new MobxReactForm({fields}, {plugins});
